import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IPaymentInformationState } from '../store/paymentInformation.types'
import { PaymentInformationConstants } from '../store/paymentInformation.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPaymentInformationSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* savePaymentInformation() {
  const paymentInformation: IPaymentInformationState = yield select(getPaymentInformationSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  try {
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = {
        ...pcrDoc,
        billing: { ...pcrDoc.billing, paymentInformation },
      }
      try {
        yield put(setHasPatient(true))
        yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      } catch (e) {
        yield put(throwPcrException(`savePaymentInformation() error: ${e}`))
      }
    } else {
      // todo: add to audit log
    }
  } catch (e) {
    yield put(throwPcrException(`savePaymentInformation() error: ${e}`))
  }
}
export function* savePaymentInformationSaga() {
  yield takeLatest(
    [
      PaymentInformationConstants.SET_X12_PAYER_TYPE,
      PaymentInformationConstants.SET_PRIMARY_METHOD_OF_PAYMENT,
      PaymentInformationConstants.SET_PRIMARY_METHOD_OF_PAYMENT_PNNV,
      PaymentInformationConstants.SET_PRIOR_AUTHORIZATION_PAYER,
      PaymentInformationConstants.SAVE_PAYMENT_INFORMATION,
    ],
    performWithMutexHOG,
    savePaymentInformation
  )
}
